module.exports = __webpack_public_path__ + "static/media/facebook.959fe9c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/facebook.svg
// module id = 243
// module chunks = 0